import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Get the base URL from the environment or use '/'
const publicUrl = process.env.PUBLIC_URL || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={publicUrl}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 